export default "__VITE_ASSET__Ce7Woknj__"